const containerData= [
    "todo",
    "priority",
    "completed",
     "ongoing"
]

export {containerData}